export default [
  {
    shape: "法器",
    name: "濟公扇",
    code: "AF",
    accessory: [5],
    way: ["F", "G"],
    engravingContentType: "sacredObject",
  },
  {
    shape: "法器",
    name: "媽祖扇",
    code: "AG",
    accessory: [5],
    way: ["G"],
    engravingContentType: "sacredObject",
  },
  {
    shape: "法器",
    name: "關聖帝君法器",
    code: "AY",
    accessory: [5],
    way: ["K"],
    engravingContentType: "sacredObject",
  },
  {
    shape: "法器",
    name: "中潭元帥法器",
    code: "AZ",
    accessory: [5],
    way: ["L"],
    engravingContentType: "sacredObject",
  },
];
